module.exports = __webpack_public_path__ + "static/media/Espurr_gaussian2.d2e8e962.png";